import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-button-image',
  templateUrl: './button-image.component.html',
  styleUrls: ['./button-image.component.scss']
})
export class ButtonImageComponent implements OnInit {
  @Input() image;
  @Input() text;
  @Input() url;
  @Input() param = null;
  applySmallText: boolean
  constructor(private router: Router) { } 

  ngOnInit(): void {
    if (this.text.length > 52) {
      this.applySmallText = true;
    } else {
      this.applySmallText = false;
    }
  }

  routeTo() {
    this.router.navigate([this.url, this.param], {skipLocationChange:true});
  }

}
